export var UPDATE_GNB = 'UPDATE_GNB';
export var UPDATE_CATEGORIES = 'UPDATE_CATEGORIES';
export var UPDATE_LATEST_POSTS = 'UPDATE_LATEST_POSTS';
export var UPDATE_CHART_POSTS = 'UPDATE_CHART_POSTS';
export var UPDATE_CATE_POSTS = 'UPDATE_CATE_POSTS';
export var UPDATE_CURRENT_CATE = 'UPDATE_CURRENT_CATE';
export var UPDATE_TAG_POSTS = 'UPDATE_TAG_POSTS';
export var UPDATE_EDITOR_POSTS = 'UPDATE_EDITOR_POSTS';
export var UPDATE_CURRENT_EDITOR = 'UPDATE_CURRENT_EDITOR';
export var UPDATE_SEARCH_ARTICLES = 'UPDATE_SEARCH_ARTICLES';
export var UPDATE_DISPLAY_CATE_DATA = 'UPDATE_DISPLAY_CATE_DATA';
export var UPDATE_DISPLAY_DATA = 'UPDATE_DISPLAY_DATA';
export var UPDATE_DISPLAY_PAGE = 'UPDATE_DISPLAY_PAGE';
export var PUSH_LIST_OF_CALLED_API = 'PUSH_LIST_OF_CALLED_API';
export var CHANGE_SIZE_TOAST_BANNER = 'CHANGE_SIZE_TOAST_BANNER';
export var CHANGE_OPEN_SHARE_DIALOG = 'CHANGE_OPEN_SHARE_DIALOG';
export var CHANGE_OPEN_FOOTER1_DIALOG = 'CHANGE_OPEN_FOOTER1_DIALOG';
export var CHANGE_OPEN_FOOTER2_DIALOG = 'CHANGE_OPEN_FOOTER2_DIALOG';
export var CHANGE_OPEN_FOOTER3_DIALOG = 'CHANGE_OPEN_FOOTER3_DIALOG';
export var CHANGE_OPEN_FAQ_DIALOG = 'CHANGE_OPEN_FAQ_DIALOG';
export var CHANGE_OPEN_TEAM_DIALOG = 'CHANGE_OPEN_TEAM_DIALOG';
export var UPDATE_OPEN_DROPDOWN = 'UPDATE_OPEN_DROPDOWN';
export var UPDATE_CURRENT_CONTENTS_DATA = 'UPDATE_CURRENT_CONTENTS_DATA';